import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

import Navigation from '../../components/Navigation/Navigation';
import ColorScheme from '../../components/ColorScheme/ColorScheme';
import Icon from '../../components/Icon/Icon';

class Landing extends Component {
	state = {
		colors: {
			color1: '#009AB8',
			color2: '#7D55A3'
		}
	};
	
	render() {
		return (
			<Fragment>
				<ColorScheme { ...this.state.colors } />
				<div className="Landing">
					<div className="landing-main">
						<Icon icon="landing" className="landing-image" title="Welcome Image" gradient="vertical" />
						<div className="landing-main-welcome">
							<Icon icon="welcome" className="welcome-text" title="Welcome to the Team!" gradient="vertical" />
							<Link to="/about-our-company">
								Where do I start?
							</Link>
						</div>
					</div>
					<Navigation horizontal />
				</div>
			</Fragment>
		);
	}
};

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/Landing/Landing.js